import { useState } from 'react'
import { useMutation } from '@apollo/client/react'
import { Modal, Button, Group, Stack, Text, Alert } from '@mantine/core'
import { IconCheck, IconAlertCircle } from '@tabler/icons-react'
import SendVerification from '../graphql/queries/SendVerification'

export default function VerificationRequiredModal({ opened, onClose, onLoginClick, ...props }) {
    const [emailSent, setEmailSent] = useState(false)
    const [message, setMessage] = useState('')
    const [messageType, setMessageType] = useState('error') // 'error' or 'success'

    const [sendVerificationMutation, { loading }] = useMutation(SendVerification)

    async function resendEmail() {
        const email = localStorage.getItem('email')
        if (!email) {
            setMessage('Unknown email address. Try logging in again, and then resend the verification email.')
            setMessageType('error')
            return
        }
        try {
            const response = await sendVerificationMutation({ variables: { email } })
            if (response.data?.sendVerification) {
                setEmailSent(true)
                setMessage('The verification email was re-sent. Please check your inbox.')
                setMessageType('success')
            } else {
                const error = response.data?.sendVerification?.error || 'Failed to send verification email'
                setMessage(error)
                setMessageType('error')
            }
        } catch (err) {
            setMessage(err.message)
            setMessageType('error')
        }
    }

    function handleLogInClick() {
        onLoginClick?.()
        onClose?.()
    }

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Verify Your Email"
            centered
            {...props}
        >
            <Stack gap="md" style={{ marginTop: '1em' }}>
                <Text size="sm">
                    Check your email for a verification link. You can log in right away, but some features (like creating rooms) require a verified account.
                </Text>

                {message && (
                    <Alert
                        color={messageType === 'success' ? 'green' : 'red'}
                        variant="light"
                        icon={messageType === 'success' ? <IconCheck size={16} /> : <IconAlertCircle size={16} />}
                    >
                        {message}
                    </Alert>
                )}

                <Group justify="flex-end" mt="xs">
                    <Button
                        variant="light"
                        disabled={loading || emailSent}
                        loading={loading}
                        onClick={resendEmail}
                    >
                        Resend Verification Email
                    </Button>
                    <Button onClick={handleLogInClick}>
                        Log In
                    </Button>
                </Group>
            </Stack>
        </Modal>
    )
}
